/**
 * Input Component
 *
 * @file Input.js
 */

import $ from "jquery";
import 'select2/dist/css/select2.css';
import 'select2';
const inputs = (() => {

  const inputQuantity = () => {
    if(document.querySelectorAll('.quantityDecrease')){
      document.querySelectorAll('.quantityDecrease').forEach(button => {
        button.addEventListener('click', function() {
            let quantityInput = this.parentElement.querySelector('.quantityInput');
            let currentValue = parseInt(quantityInput.value);
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }
        });
    });
    
    document.querySelectorAll('.quantityIncrease').forEach(button => {
        button.addEventListener('click', function() {
            let quantityInput = this.parentElement.querySelector('.quantityInput');
            let currentValue = parseInt(quantityInput.value);
            let maxLength = quantityInput.getAttribute('maxlength');
            let maxValue = Math.pow(10, maxLength) - 1; 
    
            if (currentValue < maxValue) {
                quantityInput.value = currentValue + 1;
            }
        });
    });
    }
  };

  const inpuytexpireDate = () => {
    if(document.getElementById('expireDate')){
      document.getElementById('expireDate').addEventListener('input', function(e) {
        var input = e.target;
        var value = input.value;
  
        if (value.length === 2 && value.indexOf('/') === -1) {
            input.value = value + '/';
        }
  
        if (value.length > 3 && value.charAt(2) !== '/') {
            input.value = value.slice(0, 2) + '/' + value.slice(2);
        }
  
        if (value.length === 3 && value.charAt(2) === '/') {
            input.value = value.slice(0, 2);
        }
      });
      document.getElementById('cardNumber').addEventListener('input', function(event) {
        var input = event.target.value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
        var formattedInput = input.match(/.{1,4}/g);
        if (formattedInput) {
            event.target.value = formattedInput.join(' ');
        }
      });
    }
  };
  const buttonModalToggle = () => {
    let modalStack = [];

    function openModal(modalId) {
      const modal = document.querySelector(`[data-id="${modalId}"]`);
      if (modal) {
        
        if (modalStack.length > 0) {
          const previousModal = modalStack[modalStack.length - 1];
          previousModal.style.display = 'none';
        }

        modal.classList.add('modal-open');
        modal.classList.remove('modal-close');
        modal.style.display = 'block';
        modalStack.push(modal); 

        if (modalStack.length === 1) {
          document.body.classList.add("hidden");
        }
      }
    }

    
    function closeModal(modalId) {
      const modal = document.querySelector(`[data-id="${modalId}"]`);
      if (modal) {
        modal.classList.add('modal-close');
        modal.classList.remove('modal-open');
        modal.style.display = 'none';
        modalStack.pop(); 

        
        if (modalStack.length > 0) {
          const previousModal = modalStack[modalStack.length - 1];
          previousModal.style.display = 'block';
        } else {
          document.body.classList.remove("hidden");
        }
      }
    }

    document.querySelectorAll('[data-toogle-s-modal]').forEach(button => {
      button.addEventListener('click', function() {
        const modalId = this.getAttribute('data-toogle-s-modal');
        openModal(modalId);
      });
    });

    document.querySelectorAll('.modal-close').forEach(button => {
      button.addEventListener('click', function() {
        const modal = this.closest('.payment-modal');
        if (modal) {
          closeModal(modal.getAttribute('data-id'));
        }
      });
    });

    document.addEventListener('click', function(event) {
      if (event.target.matches('.modal-backdrop')) {
        const modal = event.target.closest('.payment-modal');
        if (modal) {
          closeModal(modal.getAttribute('data-id'));
        }
      }
    });
  };

  const modalMobileRemoveEdit = () => {
    // $(".ad-more").on('click', function(event) {
    //   $(this).find(".more-pop").toggleClass("active");
    // });
    document.querySelectorAll('.ad-more').forEach(function(element) {
      element.addEventListener('click', function(event) {
        const screenWidth = window.innerWidth;
        event.stopPropagation(); 
        event.preventDefault(); 
        const clickedMorePop = this.querySelector('.more-pop');
        document.querySelectorAll('.ad-more').forEach(otherElement => {
            if (otherElement !== this) {
                const otherMorePop = otherElement.querySelector('.more-pop');
                if (otherMorePop) {
                    otherMorePop.classList.remove('active');
                }
            }
        });

        if (clickedMorePop) {
            clickedMorePop.classList.toggle('active');
        }
      });
    });
  };

  const select2Input = () => {
    const placeholderText = $('.my-select').data('placeholder');
    $('.my-select').select2({
      placeholder: placeholderText
    });
  };

  const removeBgClose = () => {
    const closeIcon = $('.trial-product-mid .remove-p');
    closeIcon.on('click', function(event) {
      $(this).closest('.item').remove();
    });
  };

  const productButtonAnim = () => {
    document.querySelectorAll('.add-to-cart-btn').forEach(button => {
      button.addEventListener('click', function() {
          const loadingText = this.getAttribute('data-loading-text'); // Yükleme metni
          const successText = this.getAttribute('data-success-text'); // Başarı metni
          const originalText = this.querySelector('span').textContent; // Orijinal metni sakla
  
          // Yükleme durumu
          this.querySelector('span').textContent = loadingText; // Yükleme metni
          this.disabled = true; // Butonu devre dışı bırak
  
          // 2 saniye sonra başarı mesajını göster
          setTimeout(() => {
              this.querySelector('span').textContent = successText; // Başarı metni
              // 3 saniye sonra geri dönecek
              setTimeout(() => {
                  this.querySelector('span').textContent = originalText; // Orijinal metne geri dön
                  this.disabled = false; // Butonu tekrar etkinleştir
              }, 3000); // 3 saniye bekle
          }, 2000); // 2 saniye yükleme süresi
      });
    });
  };

  const init = () => {
    inputQuantity();
    inpuytexpireDate();
    buttonModalToggle();
    modalMobileRemoveEdit();
    select2Input();
    removeBgClose();
    productButtonAnim();
  };

  return {
    init,
  };
})();

export default inputs;
